import SectionCard, {
  SectionCardGroup
} from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import UpgradeCard from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeCard";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { DynamicTextProps } from "@theorgchartdev/storybook/dist/components/Text/DynamicText";

const kAdminLogHelpArticle =
  "https://theorgchart.zendesk.com/hc/en-us/articles/49501649571476-Admin-log";

const UpgradeAuditLog = () => {
  const upgradeAuditLogDynamicText: DynamicTextProps = {
    template: appstr("admin log upgrade template"),
    formatConfig: { bold1: { type: "bold" }, bold2: { type: "bold" } },
    replaceDict: { bold1: appstr("audit-ready"), bold2: appstr("timestamped record") }
  };

  return (
    <SectionCardGroup>
      <SectionCard
        title={appstr("Audit log")}
        customCardStyle={{ background: "var(--bg-brand-secondary)" }}
      >
        <div className="ocn-upgrade-card-text">
          <UpgradeCard
            iconName={"file-shield"}
            featureKey={enumFeaturesList.adminLog}
            learnMoreUrl={kAdminLogHelpArticle}
          >
            <UpgradeInfoCard.Body dynamic={upgradeAuditLogDynamicText}>
              {appstr("admin log upgrade message")}
            </UpgradeInfoCard.Body>
          </UpgradeCard>
        </div>
      </SectionCard>
    </SectionCardGroup>
  );
};

export default UpgradeAuditLog;
